export enum Period {
    Year = 'Year',
    Quarter = 'Quarter',
    Month = 'Month',
    Daily = 'Daily',
    D260 = 'D260',
    D252 = 'D252',
}
